import { JoeProcessDetailsItem, Schema } from "../../../../../@types";

export const schema: Schema<JoeProcessDetailsItem> = {
  fields: [
    {
      name: "k_type",
      displayTitle: "Type",
      sortable: true,
      component: d => <>{d.k_type}</>,
      style: { width: "15%" }
    },
    {
      name: "k_tick",
      displayTitle: "Time",
      sortable: true,
      component: d => <>{d.k_tick}</>,
      style: { width: "10%" }
    },
    {
      name: "k_symbol",
      displayTitle: "API",
      sortable: true,
      component: d => <>{d.k_symbol}</>,
      style: { width: "15%" }
    },
    {
      name: "k_",
      displayTitle: "Data",
      sortable: true,
      // eslint-disable-next-line no-underscore-dangle
      component: d => <>{d.k_}</>,
      style: { width: "40%" }
    },
    {
      name: "k_status",
      displayTitle: "Status",
      sortable: true,
      component: d => <>{d.k_status}</>,
      style: { width: "15%" }
    },
    {
      name: "k_ret",
      displayTitle: "Return",
      sortable: true,
      component: d => <>{d.k_ret}</>,
      style: { width: "10%" }
    }
  ]
};
